@if (loading) {
  <app-loading [loading]="true" [height]="'24px'" [width]="'24px'" [align]="'center'"></app-loading>
} @else {
  <button
    type="button"
    class="report-download-action__btn"
    [disabled]="!reportId"
    (click)="onDownloadClick($event)"
    [attr.aria-label]="'FARMER_RECOMMENDATIONS_REPORT_LINK' | translate"
  >
    <img [src]="'doc' | iconPath" width="24" height="24" alt="" />
  </button>
}
